import {
  Component,
  forwardRef,
  Input,
  Injector,
  OnInit,
  AfterContentInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
  NgModel,
} from '@angular/forms';
import { Dropdown } from 'primeng/dropdown';

import { FormCommonFunctions2 } from '../form-common-functions';

@Component({
  selector: 'appForm2-list-dropDown',
  styleUrls: ['../form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ListFormDropDown2Component),
      multi: true,
    },
  ],
  template: `
    <div class="p-col-12 p-g-nopad">
      <div class="p-inputgroup">
        <button
          pButton
          *ngIf="dropDownParams['leftIcon']"
          type="button"
          [disabled]="dropDownParams['disabled'] || disabled"
          [icon]="dropDownParams['leftIcon']"
          (click)="triggerLeftFunc()"
          class="p-button-secondary"
        ></button>
        <p-dropdown
          #dropdown
          [appendTo]="appendTo"
          [styleClass]="dropDownParams['styleClass'] || 'form-control'"
          [class.form-control-danger]="control.showErrors || null"
          [options]="dropDownParams['options']"
          [filter]="dropDownParams['filter']"
          [(ngModel)]="value"
          [group]="dropDownParams['group'] || false"
          (onBlur)="onTouched()"
          (onChange)="pushChanges($event.value)"
          (onShow)="onShow($event)"
          [attr.id]="htmlAttributes['input']['id']"
          [filterBy]="dropDownParams['filterBy'] || 'label'"
          [disabled]="dropDownParams['disabled'] || disabled"
          [placeholder]="dropDownParams['placeholder'] || null"
          [attr.form-control-name]="control['name']"
          [style]="
            control.showErrors
              ? { border: 'solid 1px #f25858', width: '100%' }
              : { width: '100%' }
          "
          [panelStyleClass]="panelStyleClass"
        >
          <ng-template let-item pTemplate="selectedItem">
            <div class="dot {{ item?.dotClass }}" *ngIf="item?.dot"></div>
            {{ item.label }}
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="dot {{ item?.dotClass }}" *ngIf="item?.dot"></div>
            <div>{{ item.label }}</div>
          </ng-template>
        </p-dropdown>
        <button
          pButton
          *ngIf="dropDownParams['rightIcon']"
          type="button"
          [disabled]="dropDownParams['disabled'] || disabled"
          [icon]="dropDownParams['rightIcon']"
          (click)="triggerRightFunc()"
          class="p-button-secondary"
        ></button>
      </div>
      <div *ngIf="control.showErrors" class="vendium-tool-tip">
        <p
          *ngFor="let error of control.mergedErrors"
          class="form-control-feedback"
        >
          <span><i class="fa fa-times"></i> </span
          ><span [innerHTML]="error"></span>
        </p>
      </div>
    </div>
  `,
})
export class ListFormDropDown2Component
  extends FormCommonFunctions2
  implements ControlValueAccessor, OnInit, AfterContentInit
{
  @Input() public dropDownParams: any;
  @Input() public disabled: boolean;
  @Input() public panelStyleClass: string;

  @Output() public show: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('dropdown') public dropdownElement: Dropdown;

  value: NgModel;
  onChange: (value: any) => void;
  onTouched: () => void;
  ngControl: NgControl;

  constructor(private inj: Injector) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.ngControl = this.inj.get(NgControl);
    this.control = this.ngControl;
  }

  ngAfterContentInit() {
    this.control = this.ngControl.control;
  }

  writeValue(value: any): void {
    this.value = value !== undefined ? value : null;
  }

  pushChanges(value: any) {
    this.onChange(value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /** bubbles up the onShow event */
  public onShow(event: any): void {
    this.show.emit(event);
  }

  /** triggers the hide functio nin the parent */
  public hide(event: any): void {
    if (this.dropdownElement.hide) {
      this.dropdownElement.hide();
    }
  }
}
